import { useAuth } from "react-oidc-context"
import { get, includes } from "lodash"
import { useEffect } from "react"
import { useDispatch } from "react-redux"

import { oidcConfig } from "../../oidcConfig"
import { appInit, setScreenMode, setStandardMode, setTerminalMode } from "../../actions/app"
import { isTerminalPage, isScreenPage } from "../../utils/checkLocation"

const backupAdamosIssuer = process.env.REACT_APP_OIDC_ISSUER

export const useInit = (location, authenticated, backendStarting, salesRecover) => {
  const dispatch = useDispatch()
  const isTerminal = isTerminalPage(location)
  const isScreen = isScreenPage(location)

  const authAdamos = useAuth()
  const authenticatedOnAdamos = authAdamos.isAuthenticated

  const params = new URLSearchParams(location.search)
  const issuerFromURL = params.get("iss")
  const jumpFromADAMOS = includes(issuerFromURL, oidcConfig.authority) || includes(issuerFromURL, backupAdamosIssuer)

  useEffect(() => {
    if (jumpFromADAMOS) {
      authAdamos.signinRedirect()
    }
  }, [issuerFromURL])

  useEffect(() => {
    if (authenticatedOnAdamos && !authenticated) {
      dispatch(appInit(get(authAdamos, "user.access_token"), backendStarting, salesRecover)) // adamos login
    }
  }, [authenticatedOnAdamos])

  useEffect(() => {
    if (backendStarting || salesRecover) {
      dispatch(appInit(null, backendStarting, salesRecover))
    }
  }, [backendStarting, salesRecover])

  useEffect(() => {
    if (isTerminal) {
      dispatch(setTerminalMode())
    } else if (isScreen) {
      dispatch(setScreenMode())
    } else {
      dispatch(setStandardMode())
    }
    if (!jumpFromADAMOS && !authenticatedOnAdamos) {
      dispatch(appInit(null, backendStarting, salesRecover)) // page renew + active directory login
    }
  }, [])
}
